import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { HttpParams } from '@angular/common/http';
import { Literals } from '../literals';

@Injectable({
  providedIn: 'root'
})
export class GithubIntegrationService {

  constructor(private rest: RestService) { }

  public getGithubUserDataByUsername(): any {
    return this.rest.get("getGithubUserDataByUsername", null);
  }

  public getGithubIntegrationUrl(): any {
    return this.rest.get("getGithubIntegrationUrl", null);
  }

  public getGithubAuthenticationUrl(): any {
    return this.rest.get("getGithubAuthenticationUrl", null);
  }

  public getGithubReposByUser(): any {
    return this.rest.get("getGithubReposByUser", null);
  }

  public getGithubRepoBranchesByRepo(repo: string, pageNumber: string): any {
    const params = new HttpParams().set('repoFullName', repo).set("pageNumber", pageNumber);
    return this.rest.getWithParams("getGithubRepoBranchesByRepo", null, params);
  }

  public getGithubRepoCommitsByRepoBranch(repo: string, branch: string, pageNumber: string): any {
    const params = new HttpParams().set('repoFullName', repo).set("repoBranchName", branch).set("pageNumber", pageNumber);
    return this.rest.getWithParams("getGithubRepoCommitsByRepoBranch", null, params);
  }

  public addUserByInstallationId(installationId: string, code: string): any {
    return this.rest.post("addUserByInstallationId", code, installationId);
  }

  public refreshUserAccessTokenByGithubUserModelId(githubUserModelId: any): any {
    const id = githubUserModelId.$oid ? githubUserModelId.$oid : githubUserModelId;
    return this.rest.put("refreshUserAccessTokenByGithubUserModelId", id);
  }

  public updateAccessTokenByCode(code: string): any {
    return this.rest.put("updateAccessTokenByCode", code);
  }

  public isGithubIntegrated(): any {
    return this.rest.get("isGithubIntegrated", null);
  }

  public deleteGithubIntegration(): any {
    return this.rest.delete("deleteGitIntegration", null);
  }


  /** True when the server reports that both GitHub tokens are unusable and the user must authorize again. */
  public isReauthRequired(res: any): boolean {
    return !!res && res["operationStatus"] == "ERROR" &&
      typeof res["operationMessage"] === "string" &&
      res["operationMessage"].includes(Literals.GITHUB_REAUTH_REQUIRED);
  }
}
